import { Paper, Typography } from "@material-ui/core";
import { Link } from "react-router-dom";
import Box from "@material-ui/core/Box";
import { useTranslation } from "react-i18next";
export function PlusCodeInfo(props) {
  const { t, i18n } = useTranslation("mapPage");
  return (
    <Box>
      {/* <Paper> */}
      {/* <Typography color="textPrimary" variant="h5"><u>Plus Codes </u></Typography> */}
      <Typography color="textPrimary">
        <b>
          <u>Plus Codes</u>
        </b>
        {t("PlusCodeInfo1")}
      </Typography>
      {/* <Link href="https://en.wikipedia.org/wiki/Open_Location_Code" target="_blank"> <b>To Know more about Plus Codes press here ..</b></Link> */}
      {/* </Paper> */}
      <Typography color="textPrimary">{t("PlusCodeInfoBtn")}</Typography>
    </Box>
  );
}

export function What3WordsInfo(props) {
  const { t, i18n } = useTranslation("mapPage");
  return (
    <>
      <Typography color="textPrimary">
        <b>
          <u>What3words</u>
        </b>

        {t("What3Wordsinfo1")}
      </Typography>
      {/* <Link href="https://en.wikipedia.org/wiki/What3words" target="_blank">
        <b>To Know more about Plus Codes press here ..</b>
      </Link> */}
      <Typography color="textPrimary">{t("What3WordsInfoBtn")}</Typography>
    </>
  );
}

export function LatLngInfo(props) {
  const { t, i18n } = useTranslation("mapPage");
  return (
    <>
      <Typography color="textPrimary">
        <b> Latitude </b> and <b> Longitude</b>
        {t("LocationInfo1")}
      </Typography>
      <Typography color="textPrimary">{t("LocationInfoBtn")}</Typography>
    </>
  );
}

export function MakaniInfo(props) {
  const { t, i18n } = useTranslation("mapPage");
  return (
    <>
      <Typography color="textPrimary">
        <b>Makani </b>
        {t("MakaniInfo1")}
      </Typography>
      <Typography color="textPrimary">{t("MakaniInfoBtn")}</Typography>
    </>
  );
}
